module.exports = __webpack_public_path__ + "img/ugly_or_beuty_wedding_2.193c2343.jpg";